import React from 'react';
import { X, Truck, TrendingUp, DollarSign, Trophy } from 'lucide-react';

export default function ExpedicaoTotal({ data, onClose }) {
    const formatBRL = (val) =>
        Number(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
            <div className="bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">

                {/* Cabeçalho */}
                <div className="flex justify-between items-center p-4 border-b border-gray-800 bg-[#161b22]">
                    <div className="flex items-center gap-2 text-orange-400 font-bold tracking-widest text-xs uppercase">
                        <Truck size={18} />
                        <span>Detalhamento de Expedição</span>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors">
                        <X size={20} />
                    </button>
                </div>

                {/* Grade de Métricas */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">

                    <div className="bg-[#161b22] p-4 rounded border border-gray-800">
                        <div className="flex justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Expedição do Dia</p>
                            <DollarSign size={14} className="text-gray-600" />
                        </div>
                        <p className="text-white text-2xl font-mono font-bold">
                            {formatBRL(data?.totalExpedicaoDia || 0)}
                        </p>
                    </div>

                    <div className="bg-[#161b22] p-4 rounded border border-gray-800">
                        <div className="flex justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Total Expedido (Mês)</p>
                            <TrendingUp size={14} className="text-gray-500" />
                        </div>
                        <p className="text-gray-400 text-2xl font-mono font-bold">
                            {formatBRL(data?.totalExpedicao || 0)}
                        </p>
                    </div>


                    <div className="bg-[#161b22] p-4 rounded border border-gray-800">
                        <div className="flex justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Expedição (Mês)</p>
                            <Trophy size={14} className="text-amber-500" />
                        </div>
                        <p className="text-amber-500 text-2xl font-mono font-bold">
                            {formatBRL(data?.valor_totalmaior)}
                        </p>
                    </div>
                    <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Frete do Mês</p>
                            <Truck size={14} className="text-red-500 opacity-70" />
                        </div>
                        <p className="text-red-400 text-2xl font-mono font-bold tracking-tighter">
                            {formatBRL(data?.TotalFreteMes)}
                        </p>
                    </div>
                </div>

                {/* Rodapé */}
                <div className="p-4 bg-[#0d1117] text-right border-t border-gray-800">
                    <button
                        onClick={onClose}
                        className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black py-2 px-8 rounded transition-all uppercase tracking-widest shadow-lg"
                    >
                        Fechar Janela
                    </button>
                </div>
            </div>
        </div>
    );
}